import "./Contact.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import EventInquiry from "./sections/EventInquiry";
import OurOperationsHub from "./sections/OurOperationsHub";
import InformativeFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <FraternalExcellenceHeader />
      <EventInquiry />
      <OurOperationsHub />
      <InformativeFooter />
    </div>;
}